import { exhaustiveCheck } from '@famly/stat_ts-utils_exhaustive-check';
/**
 * A message this long needs longer on screen than one that fits on a line, so an error above the
 * threshold gets the extended duration.
 */
const LONG_ERROR_MESSAGE_LENGTH = 80;
const successDuration = 2000;
const neutralDuration = 4000;
const errorDuration = 6000;
const longErrorDuration = 8000;
/**
 * How long a toast of this severity stays on screen before it dismisses itself, in milliseconds.
 *
 * This is the fallback for a host that does not set a duration of its own. A host that computes one
 * per message — as the Famly app does, in its global-event action creators — never reaches it.
 *
 * Cypress shortens every toast to keep suites fast by setting `window.__cypressToastDuration`. That
 * is read here on each call rather than once at module load, so a spec that sets it after the bundle
 * has been evaluated still takes effect.
 */
export const getDefaultToastDuration = (severity, message) => {
    const cypressOverride = window.__cypressToastDuration;
    // Checked rather than trusted: anything on the page can put a value here, and a non-number
    // reaches setTimeout as 0, which would take every error off the screen before it can be read.
    if (typeof cypressOverride === 'number' && cypressOverride > 0) {
        return cypressOverride;
    }
    switch (severity) {
        case 'success':
            return successDuration;
        case 'error':
            return message.length >= LONG_ERROR_MESSAGE_LENGTH ? longErrorDuration : errorDuration;
        case 'neutral':
            return neutralDuration;
        default:
            exhaustiveCheck(severity);
            return neutralDuration;
    }
};
